import { render, staticRenderFns } from "./InitialsAvatar.vue?vue&type=template&id=0c07d767&"
import script from "./InitialsAvatar.vue?vue&type=script&lang=js&"
export * from "./InitialsAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports